import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AuthCallback from "@/pages/AuthCallback";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Discover from "@/pages/Discover";
import Profile from "@/pages/Profile";
import Feed from "@/pages/Feed";
import Wallet from "@/pages/Wallet";
import Messages from "@/pages/Messages";
import Community from "@/pages/Community";
import Shop from "@/pages/Shop";
import Neighbors from "@/pages/Neighbors";
import Sponsor from "@/pages/Sponsor";
import NeighborGroup from "@/pages/NeighborGroup";
import PaymentResult from "@/pages/PaymentResult";
import AdminPage from "@/pages/Admin";
import GuardianPage from "@/pages/Guardian";
import About from "@/pages/About";
import FAQ from "@/pages/FAQ";
import Privacy from "@/pages/Privacy";
import Refund from "@/pages/Refund";
import Terms from "@/pages/Terms";
import Contact from "@/pages/Contact";
import ScrollToTop from "@/components/ScrollToTop";
import Layout from "@/components/Layout";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return <div className="min-h-screen flex items-center justify-center text-copper font-serif text-xl">Loading…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<><ScrollToTop /><Layout /></>}>
        <Route path="/" element={<Landing />} />
        <Route path="/discover" element={<Discover />} />
        <Route path="/sponsor" element={<Sponsor />} />
        <Route path="/feed" element={<Protected><Feed /></Protected>} />
        <Route path="/u/:userId" element={<Profile />} />
        <Route path="/wallet" element={<Protected><Wallet /></Protected>} />
        <Route path="/messages" element={<Protected><Messages /></Protected>} />
        <Route path="/messages/:userId" element={<Protected><Messages /></Protected>} />
        <Route path="/community" element={<Protected><Community /></Protected>} />
        <Route path="/neighbors" element={<Protected><Neighbors /></Protected>} />
        <Route path="/neighbors/:groupId" element={<Protected><NeighborGroup /></Protected>} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/admin" element={<Protected><AdminPage /></Protected>} />
        <Route path="/guardian" element={<Protected><GuardianPage /></Protected>} />
        <Route path="/payment/success" element={<PaymentResult />} />
        <Route path="/payment/cancel" element={<PaymentResult />} />
        <Route path="/about" element={<About />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/refund" element={<Refund />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/contact" element={<Contact />} />
      </Route>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
